import request from '../http'

// ==================== 定时任务 ====================

/** 分页查询定时任务列表 */
export const listJobs = (params) =>
  request({ url: '/system/jobs', method: 'get', params })

/** 获取定时任务详情 */
export const getJob = (id) =>
  request({ url: `/system/jobs/${id}`, method: 'get' })

/** 新增定时任务 */
export const createJob = (data) =>
  request({ url: '/system/jobs', method: 'post', data })

/** 修改定时任务 */
export const updateJob = (id, data) =>
  request({ url: `/system/jobs/${id}`, method: 'put', data })

/** 删除定时任务（支持批量） */
export const deleteJobs = (ids) =>
  request({ url: `/system/jobs/${ids}`, method: 'delete' })

/** 修改任务状态 */
export const changeJobStatus = (id, status) =>
  request({ url: `/system/jobs/${id}/status`, method: 'put', data: { status } })

/** 立即执行一次 */
export const runJob = (id) =>
  request({ url: `/system/jobs/${id}/run`, method: 'post' })

// ==================== 调度日志 ====================

/** 分页查询调度日志列表 */
export const listJobLogs = (params) =>
  request({ url: '/system/job-logs', method: 'get', params })

/** 获取调度日志详情 */
export const getJobLog = (id) =>
  request({ url: `/system/job-logs/${id}`, method: 'get' })

/** 删除调度日志（支持批量） */
export const deleteJobLogs = (ids) =>
  request({ url: `/system/job-logs/${ids}`, method: 'delete' })

/** 清空全部调度日志 */
export const cleanJobLogs = () =>
  request({ url: '/system/job-logs/clean', method: 'delete' })
